import pluralizeRu from './pluralizeRu.js';

export default function (days) {
    return days + ' ' + pluralizeRu(days, ['день', 'дня', 'дней']);
}
